import type { AppStyle } from 'decorators/withStyles';

const styles: AppStyle = (theme) => ({
  tableOptions: {
    position: 'absolute',
    borderRadius: '4px 4px 0 0',
    backgroundColor: '#DDEAFF',
    color: theme.palette.primary.main,
    top: '-52px',
    left: 0,
    width: '100%',
    zIndex: 2,
    padding: '12px 36px',
    display: 'flex',
    alignItems: 'center',

    '& .count': {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },

    '& .options': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',

      '& button': {
        marginLeft: 8,
      },

      '& span.material-icons': {
        marginRight: 8,
        fontSize: 18,
      },
    },
  },
});

export default styles;
